// extracted by mini-css-extract-plugin
export default {"main_button":"Button_main_button__M1Mek"};